import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { verificationVariant } from '../../constants/multiFactorAuth';
import { Record } from '../../modules/bin/utility';
import { I18n } from 'react-redux-i18n';

class RecoveryForm extends React.Component {
  componentDidUpdate = (prevProps) => {
    this.handleSecurityApprovalError(prevProps);
  };

  handleSecurityApprovalError = (prevProps) => {
    if (this.props.verificationRecord) {
      const isPrevRecordError = Record.isError(prevProps.verificationRecord);
      const isCurrentRecordError = Record.isError(
        this.props.verificationRecord
      );

      if (isCurrentRecordError && isPrevRecordError !== isCurrentRecordError) {
        this.props.handleValueChange(`${this.props.path}.recoveryCode`, null);
      }
    }
  };

  handleValueChange = (event) => {
    const value = event.target.value || '';
    this.props.handleValueChange(`${this.props.path}.recoveryCode`, value);
  };

  handleVerificationVariantChange = () => {
    this.props.handleVerificationVariantChange(verificationVariant.authCode);
    this.props.handleValueChange(`${this.props.path}.recoveryCode`, null);
  };

  render() {
    return (
      <React.Fragment>
        <Form>
          <Form.Field>
            <label>{I18n.t('authentication.mfa.recoveryCodeLabel')}</label>
            <Input
              autoFocus
              autoComplete="off"
              value={this.props.value || ''}
              onChange={this.handleValueChange}
            />
          </Form.Field>
        </Form>
        <div className="alternative-variant">
          <span className="Links" onClick={this.handleVerificationVariantChange}>
            {I18n.t('authentication.mfa.useAuthCode')}
          </span>
        </div>
      </React.Fragment>
    );
  }
}

export default RecoveryForm;
